module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"Customer Sign In"},"de":{"pageTitle":"Kundenanmeldung"}}')
  delete Component.options._Ctor
}
